module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "followerTabs"
    }
  }, [_c('mu-row', _vm._l((_vm.tabs), function(tab, tabIndex) {
    return _c('mu-col', {
      key: 'follower-tab-' + tabIndex,
      attrs: {
        "tablet": "50",
        "desktop": "50",
        "width": "50"
      }
    }, [_c('router-link', {
      staticClass: "tab",
      attrs: {
        "to": tab.route
      },
      domProps: {
        "textContent": _vm._s(tab.label)
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('mu-card', [_c('mu-list', _vm._l((_vm.items), function(item, index) {
    return _c('mu-list-item', {
      key: 'item-' + index,
      staticClass: "item",
      attrs: {
        "disableRipple": ""
      }
    }, [_c('p', {
      attrs: {
        "slot": "title"
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(item.profile_id)
        }
      },
      slot: "title"
    }, [_vm._v("\n          " + _vm._s(item.display_name) + "\n        ")]), _vm._v(" "), _c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": item.profile_large
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(item.profile_id)
        }
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.diabetes_type)
      }
    })]), _vm._v(" "), (!item.is_own_profile) ? _c('mu-flat-button', {
      staticClass: "followBtn",
      class: {
        'following': item.is_following
      },
      attrs: {
        "slot": "right",
        "disabled": item.is_sending === true,
        "icon": item.is_following ? 'person' : 'person_add',
        "label": item.is_following ? 'Unfollow' : 'Follow',
        "primary": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.followUser(item)
        }
      },
      slot: "right"
    }) : _vm._e()], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffaf17d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/FollowerItem/FollowerItem.vue
// module id = 3323
// module chunks = 1